var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fix-icon",on:{"click":function($event){return _vm.$router.push({name:'Home',params:{keepAlive:'false'}})}}},[_c('img',{attrs:{"src":require("../assets/menu/gengduomeiw.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }